import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDPaper, FDStack,
} from '@facet-wealth/design';
import { DataValueMap } from 'Helpers/Testing';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import InsightLayout
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/ProposalInsightPicker/ProposalInsightContent/InsightLayout';
import metaOverrideSet from './metaOverrideSet';

const Insights = ({
  collection,
}) => {
  const [resource] = collection;
  const { refreshPageContentCollection } = usePageContentContext();

  const list = resource.attr('facetPlanProposalCustomInsights').resources().list();

  if (list.length === 0) {
    return null;
  }

  const warningMessage = resource.attr('warningMessage');
  return (
    <FDStack direction={'column'} spacing={3}>
      <FDStack direction={'row'} spacing={1} alignItems={'center'}>
        {warningMessage && (
        <FDPaper color={'attention'} padding={300} {...DataValueMap.init('insight-warning-message').build()}>
          <FDBodyText value={warningMessage} size={'sm'} color={'textAttention'} />
        </FDPaper>
        )}
      </FDStack>
      {list.map((insight) => (
        <MetaResourceRenderer
          resource={insight}
          layout={InsightLayout}
          LayoutProps={{
            onSubmit: async () => {
              // refresh must happen after the autosave
              await refreshPageContentCollection();
            },
          }}
          metaOverrideSet={metaOverrideSet}
        />))}
    </FDStack>
  );
};

Insights.defaultProps = {
};

Insights.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default Insights;
